"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M19.2 9c.9 0 1.6.8 1.5 1.7l-1.2 9c-.1.7-.7 1.3-1.5 1.3H5.7c-.7 0-1.4-.6-1.5-1.3l-1.2-9C2.9 9.8 3.6 9 4.5 9h1.9c.1-2.5.9-4.1 2-4.9 1.1-1 2.5-1.1 3.5-1.1s2.4.1 3.5 1 1.8 2.5 1.9 5zM7.4 11.4V10h-1v1.4c0 .3.2.5.5.5s.5-.2.5-.5m0-2.4h9c-.1-2.4-.8-3.6-1.6-4.2-.9-.7-2-.8-2.9-.8-1 0-2 .1-2.9.8-.8.7-1.5 1.9-1.6 4.2m10 2.4V10h-1v1.4c0 .3.2.5.5.5s.5-.2.5-.5"
}), 'AddToBagFilled');
